var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtractCreateContentProvider = void 0;
var messages_1 = require("../../messages");
var TableauEntityType_1 = require("../../models/TableauEntityType");
var notificationHelper_1 = require("../../utils/notificationHelper");
var NotificationDefaultProvider_1 = require("../NotificationDefaultProvider");
var UserNotificationType_1 = require("../UserNotificationType");
var ExtractCreateContentProvider = (function (_super) {
    __extends(ExtractCreateContentProvider, _super);
    function ExtractCreateContentProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtractCreateContentProvider.prototype.getNotificationTitle = function (notification) {
        if (notification.type === UserNotificationType_1.UserNotificationType.CreateExtractSucceededV2) {
            return messages_1.Messages.extractCreateSucceededV2();
        }
        else {
            return messages_1.Messages.notSupportedExtractType();
        }
    };
    ExtractCreateContentProvider.prototype.getNotificationContent = function (notification) {
        var content = notification.content;
        var newLine = messages_1.Messages.newLine();
        var message = '';
        if (notification.type === UserNotificationType_1.UserNotificationType.CreateExtractSucceededV2) {
            if (notification.targetInfo.type === TableauEntityType_1.TableauEntityType.PUBLISHED_CONNECTION) {
                message += messages_1.Messages.extractContentType({ CONTENT_TYPE: notification.targetInfo.type }) + newLine;
                message += messages_1.Messages.publishedConnectionName({ PCONN_NAME: content.publishedConnectionName }) + newLine;
                message += messages_1.Messages.publishedConnectionOwnerName({ PCONN_OWNER_NAME: content.publishedConnectionOwnerName }) + newLine;
                message += messages_1.Messages.publishedConnectionSiteName({ PCONN_SITE_NAME: content.publishedConnectionSiteName }) + newLine;
                message += messages_1.Messages.publishedConnectionLuid({ PCONN_LUID: content.publishedConnectionLuid });
            }
        }
        return message;
    };
    ExtractCreateContentProvider.prototype.getMaxShownContentLineCount = function () {
        return 8;
    };
    ExtractCreateContentProvider.prototype.getErrorMessage = function (notification) {
        var _a;
        var urlError = notificationHelper_1.isNullOrUndefined((_a = notification.targetInfo) === null || _a === void 0 ? void 0 : _a.targetUrl);
        var errorMessage = '';
        if (urlError) {
            errorMessage =
                notification.content.workbookCount === 0
                    ? messages_1.Messages.extractDataSourceNotFoundErrorMessage()
                    : messages_1.Messages.extractWorkbookNotFoundErrorMessage();
        }
        return errorMessage;
    };
    return ExtractCreateContentProvider;
}(NotificationDefaultProvider_1.NotificationDefaultProvider));
exports.ExtractCreateContentProvider = ExtractCreateContentProvider;
//# sourceMappingURL=ExtractCreateContentProvider.js.map